
import React, { Component}  from 'react';

import { DetailProvider, DetailContext } from 'core/DetailProvider';
import { FormContext, FormProvider } from 'core/FormProvider';
import Layout from 'components/Dashboard/Layout';
import { YellowButton } from 'ui/Button';
import { PointForm } from './Form';


export default class PointDetail extends Component {

  onLoaded = (item) => {
    document.title = `Точка ${item.name}`;
  };

  render() {
    const { match } = this.props;
    return (
      <DetailProvider
        url={`catalog/point/${match.params.id}`}
        onLoaded={(item) => this.onLoaded(item)}
      >
        <DetailContext.Consumer>
          {detailContext => {
            let { item } = detailContext;
            return (
              <FormProvider
                url={item.meta.url}
                postSaveMessage={'Точка обновлена'}
                postSave={(item) => detailContext.updateItem(item)}
                item={item}
              >
                <FormContext.Consumer>
                {formContext => {
                  const { loading } = formContext;
                  return (
                    <Layout>
                      <Layout.Header
                        title={'Редактирование точки'}
                        backUrl={'/point'}
                      />

                      <Layout.ContentSimple>

                        <PointForm />

                        <div className={'mt-30'}>
                          <YellowButton
                            onClick={(e) => formContext.handleSubmit(e)}
                            disabled={loading}
                            size={'large'}
                          >
                            Обновить точку
                          </YellowButton>
                        </div>
                      </Layout.ContentSimple>

                    </Layout>
                  )
                }}
                </FormContext.Consumer>
              </FormProvider>
            )
          }}
        </DetailContext.Consumer>
      </DetailProvider>
    )
  }
}
